import React from 'react'

export default function BadRequest() {
  return (
    <div>Bad Request !</div>
  )
}
